import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SeasonListPage = () =>
  import('@modules/season/components/season-list-page.vue');
const SeasonFormPage = () =>
  import('@modules/season/components/season-form-page.vue');
const SeasonViewPage = () =>
  import('@modules/season/components/season-view-page.vue');
const SeasonImporterPage = () =>
  import('@modules/season/components/season-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'season',
        path: '/season',
        component: SeasonListPage,
        meta: {
          auth: true,
          permission: Permissions.values.seasonView,
        },
      },
      {
        name: 'seasonNew',
        path: '/season/new',
        component: SeasonFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.seasonCreate,
        },
      },
      {
        name: 'seasonImporter',
        path: '/season/import',
        component: SeasonImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.seasonImport,
        },
      },
      {
        name: 'seasonEdit',
        path: '/season/:id/edit',
        component: SeasonFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.seasonEdit,
        },
        props: true,
      },
      {
        name: 'seasonView',
        path: '/season/:id',
        component: SeasonViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.seasonView,
        },
        props: true,
      },
    ],
  },
];
